module.exports = __webpack_public_path__ + "static/media/storeBanner1.d7163ca6.png";